import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse, Menu, MenuListValue } from '../models/api-response.model';

export type MenuTypeFilter = 'ALL' | 'PARENT' | 'CHILD';

export interface MenuListParams {
  search?: string;
  menuType?: MenuTypeFilter;
  page?: number;
  pageSize?: number;
  parentMenuId?: number | null;
}

export interface MenuPayload {
  name: string;
  css_class: string | null;
  route_url: string | null;
  order_no: number;
  parent_menu_id: number | null;
}

@Injectable({ providedIn: 'root' })
export class MenuService {
  private readonly http = inject(HttpClient);

  list(paramsInput: MenuListParams = {}): Observable<ApiResponse<MenuListValue>> {
    let params = new HttpParams();

    if (paramsInput.search) {
      params = params.set('search', paramsInput.search);
    }
    if (paramsInput.menuType && paramsInput.menuType !== 'ALL') {
      params = params.set('menu_type', paramsInput.menuType);
    }
    if (paramsInput.parentMenuId !== undefined && paramsInput.parentMenuId !== null) {
      params = params.set('parent_menu_id', paramsInput.parentMenuId);
    }
    if (paramsInput.page) {
      params = params.set('page', paramsInput.page);
    }
    if (paramsInput.pageSize) {
      params = params.set('page_size', paramsInput.pageSize);
    }

    return this.http.get<ApiResponse<MenuListValue>>(API_ENDPOINTS.menus, { params });
  }

  create(payload: MenuPayload): Observable<ApiResponse<Menu>> {
    return this.http.post<ApiResponse<Menu>>(API_ENDPOINTS.menus, payload);
  }

  update(menuId: number, payload: MenuPayload): Observable<ApiResponse<Menu>> {
    return this.http.post<ApiResponse<Menu>>(`${API_ENDPOINTS.menus}/${menuId}/update`, payload);
  }

  delete(menuId: number): Observable<ApiResponse<''>> {
    return this.http.post<ApiResponse<''>>(`${API_ENDPOINTS.menus}/${menuId}/delete`, {});
  }
}
